import { useState } from "react";

const Dropdown = ({ label, value, options, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="dropdown">
        <label>{label}</label>
      <button
        className="btn btn-light dropdown-toggle w-100 text-left"
        type="button"
        onClick={() => setOpen(!open)}
      >
        {value || "Select"}
      </button>
      <div
        className={`dropdown-menu w-100 ${open ? "show" : ""}`}
        style={{ maxHeight: "200px", overflowY: "auto" }}
      >
        {options.map((opt) => (
          <button
            key={opt}
            className="dropdown-item"
            onClick={() => {
              onChange(opt);
              setOpen(false);
            }}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Dropdown;
